import React, { Component, Fragment } from 'react';
import {
  BrowserRouter,
  Route,
  Redirect
} from 'react-router-dom';
import './App.css';
import logo from './oil_pain.png';
import Login from './LogIn';
import UserPanel from './dashboard/UserPanel'
import Navbar from './Navbar';
import { firebase } from './firebase';
import SingUp from './SingUp'

function Home(logged)
{
  return (
    (logged)
       ?
       <Redirect to="/dashboard"/>
       :
       <Fragment>    
          <header className="App-header">
            <img src={logo} alt="logo" />
            <p>The greatest <code>CV createor</code> that ever made.</p>
            <p> Just click <b>Sing Up</b> and start your journey.</p>
          </header>
       </Fragment>
  )
}

class App extends Component {
  state = {
    logged: null,
  }
 
  componentDidMount() {
    firebase.auth.onAuthStateChanged((authenticated) => {
      authenticated
        ? this.setState(() => ({
          logged: true,
          }))
        : this.setState(() => ({
          logged: false,
          }));
    });
  }

  render() {
    if(this.state.logged == null)
    return( <div>loading</div>)
    else
    return (  
      <BrowserRouter>
          <Fragment>
            {Navbar(this.state.logged)}
            <Route exact path="/" component={() => Home(this.state.logged)}/>
            <Route path="/singup" component={SingUp} />
            <Route path="/login" component={Login}/>
            <Route path="/dashboard" component={() => <UserPanel logged={this.state.logged}/>}/>
          </Fragment>
      </BrowserRouter>   
    )
  }
}

export default App;
